import { Reducer } from 'redux';

import { TemplateListState, LandingPagesActionTypes } from './types';

export const defaultState: TemplateListState = {
    loadingTemplates: false,
    loadingTemplate: false,
    loadingLandingPagesList: false,
    page: 1,
    limit: 10,
    templatesList: [],
    landingPagesList: [],
    submitLandingPagesList: [],
    alreadySubscribedLandingPagesList: [],
    loadingSubmitLandingPages: false,
    loadingAlreadySubscribedLandingPages: false,
    count: 0,
    DeletingTemplate: false,
    name: null,
    template: null,
    templateAlreadySubscribed: null,
    templateFormSubmit: null,
    ispublic: false,
    removeScreenshot: true,
    isInfinityScroll: false,
};

const reducer: Reducer = (state: TemplateListState = defaultState, action): TemplateListState => {
    switch (action.type) {
        case '@@landingPageList/LOADING_START':
        case '@@landingPageList/LOADING_SUCCESS':
        case '@@landingPageList/LOADING_ERROR':
        case '@@landingPageList/DELETE_START':
        case '@@landingPageList/DELETE_SUCCESS':
        case '@@landingPageList/DELETE_ERROR':
        case '@@landingPageList/DELETE_ARRAY_START':
        case '@@landingPageList/DELETE_ARRAY_SUCCESS':
        case '@@landingPageList/DELETE_ARRAY_ERROR':
        case '@@landingPageList/PREVIEW_START':
        case '@@landingPageList/PREVIEW_SUCCESS':
        case '@@landingPageList/PREVIEW_ERROR':
        case '@@landingPageList/UPDATE_START':
        case '@@landingPageList/UPDATE_ERROR':
        case '@@landingPageList/SAVE_TEMPLATE_ERROR':
        case '@@landingPageList/SAVE_TEMPLATE_START':
        case '@@landingPageList/SAVE_TEMPLATE_SUCCESS':
        case '@@landingPageList/CHANGE_PAGE':
        case '@@landingPageList/DOWNLOAD_LANDING_PAGE_START':
        case '@@landingPageList/DOWNLOAD_LANDING_PAGE_SUCCESS':
        case '@@landingPageList/DOWNLOAD_LANDING_PAGE_ERROR':
        case LandingPagesActionTypes.LOADING_ALREADY_SUBSCRIBED_LANDING_PAGES_ERROR:
        case LandingPagesActionTypes.LOADING_ALREADY_SUBSCRIBED_LANDING_PAGES_START:
        case LandingPagesActionTypes.LOADING_ALREADY_SUBSCRIBED_LANDING_PAGES_SUCCESS:
        case LandingPagesActionTypes.LOADING_SUBMIT_LANDING_PAGES_ERROR:
        case LandingPagesActionTypes.LOADING_SUBMIT_LANDING_PAGES_START:
        case LandingPagesActionTypes.LOADING_SUBMIT_LANDING_PAGES_SUCCESS:
        case LandingPagesActionTypes.LOADING_LANDING_PAGE_SUBMIT_START:
        case LandingPagesActionTypes.LOADING_LANDING_PAGE_SUBMIT_SUCCESS:
        case LandingPagesActionTypes.LOADING_LANDING_PAGE_SUBMIT_ERROR:
        case LandingPagesActionTypes.LOADING_LANDING_PAGE_ALREADY_SUBSCRIBED_START:
        case LandingPagesActionTypes.LOADING_LANDING_PAGE_ALREADY_SUBSCRIBED_SUCCESS:
        case LandingPagesActionTypes.LOADING_LANDING_PAGE_ALREADY_SUBSCRIBED_ERROR:
            return { ...state, ...action.payload };
        case LandingPagesActionTypes.LOADING_LANDING_PAGE_START:
            return { ...state, ...action.payload, loadingTemplate: true };
        case LandingPagesActionTypes.LOADING_LANDING_PAGE_SUCCESS:
        case LandingPagesActionTypes.LOADING_LANDING_PAGE_ERROR:
            return { ...state, ...action.payload, loadingTemplate: false };
        case LandingPagesActionTypes.LOAD_LANDING_PAGES_LIST_START:
            return { ...state, ...action.payload, loadingLandingPagesList: true };
        case LandingPagesActionTypes.LOAD_LANDING_PAGES_LIST_SUCCESS:
            return { ...state, ...action.payload, loadingLandingPagesList: false };
        case LandingPagesActionTypes.LOAD_LANDING_PAGES_LIST_ERROR:
            return { ...state, ...action.payload, loadingLandingPagesList: false };
        case '@@landingPageList/UPDATE_SUCCESS':
            return {
                ...state,
                ...{ templatesList: action.payload.templatesList },
            };
        default:
            return state;
    }
};

export { reducer as landingPageList };

export default reducer;
